/**
 * on record Brand Colors
 * Centralized color definitions for consistent branding across the platform
 */

export const ONRECORD_BRAND = {
  // Primary brand colors
  PRIMARY: '#FCA903',           // on record orange
  ORANGE: '#FCA903',            // Alias for primary

  // Avatar system colors
  AVATAR_BACKGROUND: '#FCA903', // Orange background for avatar fallback
  AVATAR_TEXT: '#FFFFFF',       // White text/initials on orange background

  // UI colors
  BORDER: '#E5E7EB',           // Light gray borders
  TEXT_PRIMARY: '#111827',      // Dark text
  TEXT_SECONDARY: '#6B7280',    // Gray text
  BACKGROUND: '#FFFFFF',        // White background
} as const

export type BrandColor = typeof ONRECORD_BRAND[keyof typeof ONRECORD_BRAND]

// Validation function for development
export function validateBranding(): boolean {
  const isValid = ONRECORD_BRAND.AVATAR_BACKGROUND === '#FCA903'
  if (import.meta.env.DEV) {
    console.log(
      isValid
        ? '✅ on record avatar branding is correctly applied'
        : '❌ WARNING: Avatar branding colors are incorrect!'
    )
  }
  return isValid
}
